import { ISO_TO_NAME } from "@/components/search/data";

export const normalizeLanguageName = (labelOrCode: string) => {
  if (!labelOrCode?.trim()) return "";
  const key = labelOrCode.trim().toLowerCase().replace("_", "-");
  return ISO_TO_NAME[key] ?? labelOrCode.toUpperCase();
};
